const comagicAddOfflineRequest = (form = { name: '', email: '', phone: '', message: '' }) => {
  const Comagic = window?.Comagic || null;
  if (!Comagic || !Comagic.addOfflineRequest) {
    return
  }

  try {
    Comagic.addOfflineRequest({...form});
  } catch (err) {
    Comagic.push(['addOfflineRequest', {
      ...form
    }]);
  }
}
export {
  comagicAddOfflineRequest
}

